import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { kenoBetStore } from '../../store/kenoBetStore';

const MobileOpenedNumbers = observer(() => {
  const { winNumbers } = kenoBetStore;

  const { topLine, bottomLine } = useMemo(() => {
    return {
      bottomLine: winNumbers.slice(0, 10) || [],
      topLine: winNumbers.slice(10) || [],
    };
  }, [winNumbers]);

  return (
    <div className='keno-game-result-items'>
      <div className='keno-game-result-row'>
        {bottomLine.map((el) => {
          return (
            <div className='ball-wrapper active' key={el}>
              <div className='ball-content'>{el}</div>
            </div>
          );
        })}
      </div>
      <div className='keno-game-result-row'>
        {topLine.map((el) => {
          return (
            <div className='ball-wrapper active' key={el}>
              <div className='ball-content'>{el}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
});
export default MobileOpenedNumbers;
